import { render, staticRenderFns } from "./nurtrientApplyPlan.vue?vue&type=template&id=2b8d8414&scoped=true"
import script from "./nurtrientApplyPlan.vue?vue&type=script&lang=js"
export * from "./nurtrientApplyPlan.vue?vue&type=script&lang=js"
import style0 from "./nurtrientApplyPlan.vue?vue&type=style&index=0&id=2b8d8414&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d8414",
  null
  
)

export default component.exports